var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBpLogo = function SvgBpLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.838 70.222"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#182f37",
    fillRule: "evenodd",
    opacity: 0.597
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.745 8.184c0 1.531-.542 3.644-2.709 3.644-2.616 0-2.616-2.934-2.616-3.55 0-.6 0-3.738 2.69-3.738 2.449 0 2.634 2.71 2.634 3.644ZM35.457 0H33.7v11.286l-.038 1.682h1.7l.038-1.421a3 3 0 0 0 .918.954 3.7 3.7 0 0 0 2.092.6 3.97 3.97 0 0 0 3.29-1.608 5.4 5.4 0 0 0 .9-3.421 4.92 4.92 0 0 0-1.1-3.531 3.84 3.84 0 0 0-2.971-1.2 3.14 3.14 0 0 0-3.065 1.607v-4.95Z",
    "data-name": "Pfad 110673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.626 8.558c0-.843 0-3.813 2.8-3.813 2.075 0 2.581 1.757 2.581 3.439a5.25 5.25 0 0 1-.767 2.934 2.4 2.4 0 0 1-1.981.916c-2.466 0-2.635-2.337-2.635-3.476Zm-1.681 8.016h1.739v-4.652a3.24 3.24 0 0 0 2.875 1.4c2.245 0 4.28-1.532 4.28-5.027 0-3.476-1.923-4.859-3.942-4.859a3.64 3.64 0 0 0-3.195 1.7l-.038-1.55h-1.776c.038.9.057 1.121.057 1.531z",
    "data-name": "Pfad 110674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.412 16.575a38 38 0 0 1 3.226 5.872 26.3 26.3 0 0 0-3.226 4.331 26 26 0 0 0-3.224-4.331 38.3 38.3 0 0 1 3.224-5.872",
    "data-name": "Pfad 110675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.412 60.018a26.3 26.3 0 0 0 3.228 4.331 37.7 37.7 0 0 1-3.228 5.873 38 38 0 0 1-3.224-5.873 26 26 0 0 0 3.224-4.331",
    "data-name": "Pfad 110676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.24 18.195a38 38 0 0 1 5.04 4.417 26 26 0 0 0-1.551 5.172 26 26 0 0 0-4.512-2.965 38 38 0 0 1 1.023-6.624",
    "data-name": "Pfad 110677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.099 59.018a26 26 0 0 0 4.511 2.965 38 38 0 0 1-1.021 6.624 39 39 0 0 1-5.042-4.418 26 26 0 0 0 1.553-5.17Z",
    "data-name": "Pfad 110678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 22.851a38 38 0 0 1 6.246 2.427c-.016.415-.031.831-.031 1.237a25 25 0 0 0 .338 4.151 26 26 0 0 0-5.248-1.241 38 38 0 0 1-1.3-6.573Z",
    "data-name": "Pfad 110679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.441 60.287a25.3 25.3 0 0 0-.338-4.155 26 26 0 0 0 5.247 1.241 38 38 0 0 1 1.3 6.572 37.6 37.6 0 0 1-6.245-2.423c.016-.415.031-.83.031-1.234Z",
    "data-name": "Pfad 110680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.885 30.132a26 26 0 0 0 2.132 4.948 26 26 0 0 0-5.356.637 37.7 37.7 0 0 1-3.474-5.732 38 38 0 0 1 6.7.146Z",
    "data-name": "Pfad 110681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.168 51.078a38 38 0 0 1 3.475 5.732 38 38 0 0 1-6.7-.143 26 26 0 0 0-2.131-4.952 25.6 25.6 0 0 0 5.356-.636Z",
    "data-name": "Pfad 110682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.344 36.583a26 26 0 0 0 3.7 3.929 26 26 0 0 0-4.818 2.426 37.7 37.7 0 0 1-5.223-4.2 38 38 0 0 1 6.344-2.156Z",
    "data-name": "Pfad 110683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.606 43.858a38 38 0 0 1 5.223 4.2 38 38 0 0 1-6.347 2.156 25.8 25.8 0 0 0-3.7-3.926 26 26 0 0 0 4.826-2.427Z",
    "data-name": "Pfad 110684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.226 43.858a26 26 0 0 0 4.823 2.427 26 26 0 0 0-3.7 3.926 38 38 0 0 1-6.344-2.156 38 38 0 0 1 5.223-4.2Z",
    "data-name": "Pfad 110685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.482 36.582a38 38 0 0 1 6.347 2.158 38 38 0 0 1-5.223 4.2 26 26 0 0 0-4.826-2.425 25.6 25.6 0 0 0 3.7-3.931Z",
    "data-name": "Pfad 110686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66 51.078a25.5 25.5 0 0 0 5.356.636 26 26 0 0 0-2.132 4.951 38 38 0 0 1-6.7.145 38 38 0 0 1 3.474-5.732Z",
    "data-name": "Pfad 110687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.643 29.985a38 38 0 0 1-3.475 5.732 26 26 0 0 0-5.356-.637 26 26 0 0 0 2.131-4.95 38 38 0 0 1 6.7-.145",
    "data-name": "Pfad 110688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.725 56.134a25.3 25.3 0 0 0-.338 4.155c0 .4.015.818.031 1.234a38 38 0 0 1-6.246 2.423 38 38 0 0 1 1.3-6.572 26 26 0 0 0 5.248-1.241Z",
    "data-name": "Pfad 110689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.655 22.851a38 38 0 0 1-1.3 6.573 26 26 0 0 0-5.247 1.241 25.3 25.3 0 0 0 .338-4.154c0-.406-.014-.819-.033-1.234a38 38 0 0 1 6.247-2.427Z",
    "data-name": "Pfad 110690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.729 59.018a26 26 0 0 0 1.552 5.17 38.3 38.3 0 0 1-5.04 4.417 38 38 0 0 1-1.023-6.622 26.2 26.2 0 0 0 4.511-2.965",
    "data-name": "Pfad 110691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.588 18.191a38 38 0 0 1 1.021 6.626 26 26 0 0 0-4.511 2.965 26 26 0 0 0-1.553-5.172 38.5 38.5 0 0 1 5.042-4.419Z",
    "data-name": "Pfad 110692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.861 23.256a24.6 24.6 0 0 1 3.111 4.3 18.2 18.2 0 0 0-1.617 4.167 18.2 18.2 0 0 0-2.944-3.362 24.6 24.6 0 0 1 1.45-5.1Z",
    "data-name": "Pfad 110693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.473 55.076a18 18 0 0 0 2.946 3.36 24.8 24.8 0 0 1-1.453 5.107 24.7 24.7 0 0 1-3.111-4.3 18.2 18.2 0 0 0 1.617-4.164Z",
    "data-name": "Pfad 110694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.163 26.515c0-.273.014-.553.022-.832a24.7 24.7 0 0 1 4.394 2.979 19 19 0 0 0-.2 2.676 17 17 0 0 0 .1 1.79 18.3 18.3 0 0 0-3.917-2.153 24 24 0 0 1-.4-4.462Z",
    "data-name": "Pfad 110695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.447 55.457a17 17 0 0 0-.1-1.793 18.2 18.2 0 0 0 3.919 2.157 24 24 0 0 1 .4 4.466c0 .27-.012.549-.017.824a24.5 24.5 0 0 1-4.4-2.977 19 19 0 0 0 .2-2.678Z",
    "data-name": "Pfad 110696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.744 30.252a25 25 0 0 1 5.147 1.293 18.1 18.1 0 0 0 1.44 4.235 18.1 18.1 0 0 0-4.417-.687 24.7 24.7 0 0 1-2.17-4.841",
    "data-name": "Pfad 110697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.494 51.018a18.2 18.2 0 0 0 4.418.687 24.5 24.5 0 0 1 2.172 4.842 24.6 24.6 0 0 1-5.149-1.3 18 18 0 0 0-1.44-4.232Z",
    "data-name": "Pfad 110698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.47 35.857a18.3 18.3 0 0 0 2.8 3.489 18.1 18.1 0 0 0-4.384.866 24.6 24.6 0 0 1-3.7-3.81 24.8 24.8 0 0 1 5.278-.545Z",
    "data-name": "Pfad 110699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.941 46.584a24.7 24.7 0 0 1 3.7 3.813 24.8 24.8 0 0 1-5.278.546 18.5 18.5 0 0 0-2.8-3.491 18 18 0 0 0 4.384-.867Z",
    "data-name": "Pfad 110700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.735 41.083a18.2 18.2 0 0 0 3.822 2.319 18 18 0 0 0-3.822 2.313 24.7 24.7 0 0 1-4.775-2.313 24.4 24.4 0 0 1 4.775-2.319",
    "data-name": "Pfad 110701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.098 41.083a24.5 24.5 0 0 1 4.775 2.316 24.6 24.6 0 0 1-4.775 2.316 18 18 0 0 0-3.824-2.313 18.2 18.2 0 0 0 3.824-2.319",
    "data-name": "Pfad 110702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.889 46.584a18 18 0 0 0 4.384.867 18.3 18.3 0 0 0-2.8 3.491 24.8 24.8 0 0 1-5.278-.546 24.7 24.7 0 0 1 3.7-3.813Z",
    "data-name": "Pfad 110703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.638 36.402a24.8 24.8 0 0 1-3.7 3.81 18.1 18.1 0 0 0-4.384-.866 18.5 18.5 0 0 0 2.8-3.489 24.8 24.8 0 0 1 5.278.545Z",
    "data-name": "Pfad 110704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.333 51.018a18 18 0 0 0-1.44 4.232 24.6 24.6 0 0 1-5.147 1.3 24.6 24.6 0 0 1 2.169-4.842 18.3 18.3 0 0 0 4.418-.687Z",
    "data-name": "Pfad 110705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.083 30.246a24.6 24.6 0 0 1-2.172 4.842 18 18 0 0 0-4.418.687 18 18 0 0 0 1.44-4.235 24.6 24.6 0 0 1 5.149-1.294Z",
    "data-name": "Pfad 110706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.355 55.076a18.1 18.1 0 0 0 1.618 4.161 24.7 24.7 0 0 1-3.111 4.3 24.6 24.6 0 0 1-1.45-5.107 18.2 18.2 0 0 0 2.944-3.36Z",
    "data-name": "Pfad 110707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.485 53.664a17 17 0 0 0-.1 1.795 19 19 0 0 0 .2 2.676 24.5 24.5 0 0 1-4.393 2.977c-.008-.275-.022-.554-.022-.828a24 24 0 0 1 .4-4.463 18.2 18.2 0 0 0 3.917-2.157Z",
    "data-name": "Pfad 110708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.965 23.255a24.8 24.8 0 0 1 1.454 5.1 18.3 18.3 0 0 0-2.946 3.364 18.2 18.2 0 0 0-1.617-4.167 24.7 24.7 0 0 1 3.11-4.3Z",
    "data-name": "Pfad 110709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.64 25.683c.01.279.022.556.022.828a24 24 0 0 1-.4 4.465 18.2 18.2 0 0 0-3.919 2.155 17 17 0 0 0 .1-1.793 19 19 0 0 0-.2-2.678 25 25 0 0 1 4.395-2.977Z",
    "data-name": "Pfad 110710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.158 31.339a18 18 0 0 1 .13-2.029 16.9 16.9 0 0 1 2.833 3.479 15 15 0 0 0-.239 2.653c0 .383.026.769.055 1.152a15.3 15.3 0 0 0-2.587-2.8 16 16 0 0 1-.193-2.459Z",
    "data-name": "Pfad 110711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.946 51.355c0-.386-.027-.768-.057-1.154a15.4 15.4 0 0 0 2.588 2.8 15.6 15.6 0 0 1 .194 2.458 18 18 0 0 1-.13 2.03 16.9 16.9 0 0 1-2.836-3.48 15 15 0 0 0 .242-2.653Z",
    "data-name": "Pfad 110712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.777 31.915a16.8 16.8 0 0 1 3.855 2.3 15.3 15.3 0 0 0 1.128 3.643 15 15 0 0 0-3.389-1.745 16.9 16.9 0 0 1-1.594-4.2Z",
    "data-name": "Pfad 110713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.065 48.942a15.2 15.2 0 0 0 3.391 1.746 16.9 16.9 0 0 1 1.6 4.2 16.7 16.7 0 0 1-3.855-2.3 15.3 15.3 0 0 0-1.132-3.643Z",
    "data-name": "Pfad 110714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.426 35.905a16.9 16.9 0 0 1 4.409.84 15.3 15.3 0 0 0 2.307 3.038 15.3 15.3 0 0 0-3.789-.489 16.9 16.9 0 0 1-2.927-3.389",
    "data-name": "Pfad 110715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.681 47.017a15.3 15.3 0 0 0 3.793.487 16.8 16.8 0 0 1 2.923 3.392 16.8 16.8 0 0 1-4.409-.843 15.2 15.2 0 0 0-2.308-3.036Z",
    "data-name": "Pfad 110716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.08 40.077a15.3 15.3 0 0 0 3.2 2.06 15.3 15.3 0 0 0-3.711.847 16.8 16.8 0 0 1-3.917-2.19 17 17 0 0 1 4.431-.717Z",
    "data-name": "Pfad 110717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.259 43.811a16.8 16.8 0 0 1 3.918 2.193 16.8 16.8 0 0 1-4.429.716 15.3 15.3 0 0 0-3.2-2.06 15 15 0 0 0 3.712-.848Z",
    "data-name": "Pfad 110718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.566 43.811a15.3 15.3 0 0 0 3.714.85 15.2 15.2 0 0 0-3.2 2.058 16.8 16.8 0 0 1-4.431-.716 16.8 16.8 0 0 1 3.917-2.193Z",
    "data-name": "Pfad 110719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.748 40.077a16.9 16.9 0 0 1 4.429.717 16.7 16.7 0 0 1-3.918 2.19 15.2 15.2 0 0 0-3.712-.847 15.2 15.2 0 0 0 3.2-2.06Z",
    "data-name": "Pfad 110720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.148 47.018a15 15 0 0 0-2.309 3.035 16.8 16.8 0 0 1-4.408.843 16.8 16.8 0 0 1 2.925-3.392 15.4 15.4 0 0 0 3.792-.486",
    "data-name": "Pfad 110721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.397 35.905a16.9 16.9 0 0 1-2.923 3.389 15.3 15.3 0 0 0-3.793.489 15.3 15.3 0 0 0 2.308-3.038 17 17 0 0 1 4.409-.84Z",
    "data-name": "Pfad 110722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.412 50.637a15.5 15.5 0 0 0 1.476 3.515 16.8 16.8 0 0 1-1.476 4.239 17 17 0 0 1-1.476-4.239 15.2 15.2 0 0 0 1.476-3.515",
    "data-name": "Pfad 110723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.934 50.201a15 15 0 0 0-.055 1.154 15 15 0 0 0 .239 2.653 17 17 0 0 1-2.833 3.48 18 18 0 0 1-.13-2.028 16 16 0 0 1 .193-2.459 15.4 15.4 0 0 0 2.587-2.8Z",
    "data-name": "Pfad 110724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.764 48.942a15.3 15.3 0 0 0-1.128 3.643 16.8 16.8 0 0 1-3.855 2.3 16.8 16.8 0 0 1 1.594-4.2 15.2 15.2 0 0 0 3.389-1.746Z",
    "data-name": "Pfad 110725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.412 28.407a16.8 16.8 0 0 1 1.478 4.239 15.3 15.3 0 0 0-1.478 3.514 15.2 15.2 0 0 0-1.476-3.514 17 17 0 0 1 1.476-4.239",
    "data-name": "Pfad 110726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.54 29.31a18 18 0 0 1 .13 2.029 16 16 0 0 1-.192 2.459 15.4 15.4 0 0 0-2.589 2.8c.03-.384.057-.769.057-1.152a15 15 0 0 0-.242-2.653 16.8 16.8 0 0 1 2.836-3.479Z",
    "data-name": "Pfad 110727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.052 31.915a17 17 0 0 1-1.6 4.2 15.1 15.1 0 0 0-3.391 1.745 15.3 15.3 0 0 0 1.132-3.643 16.7 16.7 0 0 1 3.855-2.3Z",
    "data-name": "Pfad 110728"
  }))));
};
export default SvgBpLogo;